import { useMutation, useQueryClient } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { createContext, useState } from 'react';
import { createUserSetting } from 'Services/user';
import useUserSettings from 'Hooks/useUserSettings';

export const SettingsStorageContext = createContext();

export default function SettingsStorageProvider({ children }) {
    const { settings } = useUserSettings();

    const queryClient = useQueryClient();

    const { mutate: setSetting } = useMutation({
        mutationFn: createUserSetting,
        onMutate: (payload) => {
            queryClient.setQueryData(['settings-storage'], (old) => {
                if (!old) return old;

                return {
                    ...old,
                    [payload.field]: {
                        creation_date: new Date().toISOString(),
                        value: payload.value,
                        is_global: payload.is_global,
                    },
                };
            });
        },
    });

    return (
        <SettingsStorageContext.Provider
            value={{
                settings,
                setSetting,
            }}
        >
            {children}
        </SettingsStorageContext.Provider>
    );
}

SettingsStorageProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export function SettingsStorageProviderFake({ children, defaultSettings = {} }) {
    const [settings, setSettings] = useState(defaultSettings);
    return (
        <SettingsStorageContext.Provider
            value={{
                settings,
                setSetting: (newSetting) => {
                    setSettings((oldSettings) => ({
                        ...oldSettings,
                        [newSetting.field]: {
                            creation_date: new Date().toISOString(),
                            value: newSetting.value,
                            is_global: newSetting.is_global,
                        },
                    }));
                },
            }}
        >
            {children}
        </SettingsStorageContext.Provider>
    );
}

SettingsStorageProviderFake.propTypes = {
    children: PropTypes.node.isRequired,
    defaultSettings: PropTypes.object,
};
